export const autocompleteFilterStyles = {
	inputContainer: (indicateError: boolean, isDirty: boolean) => ({
		backgroundColor: 'background.paper',
		borderRadius: 1,

		'& .MuiOutlinedInput-input': {
			color: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-text-primary)',
			WebkitTextFillColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-text-primary)',
			pr: 1.25
		},

		'& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
			borderColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-divider)',
			borderWidth: 1
		},
		'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-action-hover)',
			borderWidth: 1
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.main',
			borderWidth: 1
		}
	}),
	input: {
		height: '42px',
		borderRadius: 1,
		color: 'text.primary',
		p: '0 0 0 12px',
		flexGrow: 1,
		border: 0,
		outline: 0
	},
	dropdownIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'row',
		alignSelf: 'center',
		cursor: 'pointer',
		margin: '0 -13px 0 -4px',
		padding: '24px 16px',
		borderRadius: 1,
		'& svg': { pointerEvents: 'none' }
	},

	badgeWrap: {
		display: 'flex',
		alignItems: 'center',
		gap: 0.5,
		pointerEvents: 'none'
	}
};
